import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";

import ViewClient from "../view";
import ViewClientSetting from "./view";
import EditClientSetting from "./edit";
import { MODULE_CLIENT } from "variables/modules";

const clientSettingRoutes = [
	generateCRUDRoutes({
		mainTitle: "Client Settings",
		basePath: "clients/:clientId/settings",
		mainComponent: <ViewClient />,
	    layout: "/console",	   
	    subTitle:"Client Setting",
	    viewComponent: <ViewClientSetting />,
	    createComponent: <EditClientSetting />,
	    editComponent: <EditClientSetting />, 
		level:3,
		moduleId: MODULE_CLIENT,  
	})
]

export default clientSettingRoutes;